import React from "react";
import PropTypes from "kf-proptypes/widgets";

import {
  SingleSelectDropdown,
  SingleSelectDropdownItem
} from "../../inputs/dropdown/index.jsx";
import { PropertiesField } from "../field/index.jsx";

import styles from "./style.css";
export function DropdownProperty({
  label,
  modified,
  value,
  dataSource,
  onChange,
  onReset,
  inheritedFrom,
  showReset,
  showInherit,
  getPanelContainer,
  size
}) {
  return (
    <PropertiesField
      inheritedFrom={inheritedFrom}
      label={label}
      modified={modified}
      onReset={onReset}
      showReset={showReset}
      showInherit={showInherit}
      getPanelContainer={getPanelContainer}
    >
      <SingleSelectDropdown
        dataSource={dataSource}
        containerClassname={styles.dropdown}
        itemRenderer={(data) => {
          return (
            <SingleSelectDropdownItem>{data.label}</SingleSelectDropdownItem>
          );
        }}
        size={size}
        labelRenderer={(data) => <div>{data.label}</div>}
        value={dataSource.find((d) => d.value === value)}
        onChange={(data) => {
          onChange(data.value);
        }}
      />
    </PropertiesField>
  );
}

DropdownProperty.propTypes = {
  label: PropTypes.string,
  modified: PropTypes.bool,
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  inheritedFrom: PropTypes.string,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  getPanelContainer: PropTypes.func,
  size: PropTypes.string
};
